import axios from "@/libs/api.request";
import config from "@/config";
import { getToken } from "@/libs/util";
import { paramFormat } from "@/api/fn";

const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;

export default {
  queryFormulaExpressionist(data) {
    let token = getToken();
    let param = {"keyword": data.keyword,"limit":data.limit,"page":data.page};
    let url = baseUrl + "/sys/formulaExpression/list?keyword="+ param.keyword +"&limit=" + param.limit+"&page=" + param.page;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //新建
  newFormulaExpression(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaExpression/save",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  // //编辑
  // updateStationById(data) {
  //   let token = getToken();
  //   return axios.request({
  //     url: baseUrl + "/sys/station/updateStationById",
  //     data: data,
  //     dataType: "json",
  //     headers: {
  //       token: token,
  //       "Content-Type": "application/json; charset=utf-8"
  //     },
  //     method: "POST"
  //   });
  // },
  // //删除
  deleteFormulaExpressionById(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaExpression/delete",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //新建公式
  newFormulaExpressionSave(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaExpression/save",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //修改公式
  newFormulaExpressionUpdate(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaExpression/update",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },

  //公式变量
  queryFormulaVar(data) {
    let token = getToken();
    let param = {"keyword": data.keyword,"limit":data.limit,"page":data.page};
    let url = baseUrl + "/sys/formulaVar/list?keyword="+ param.keyword +"&limit=" + param.limit+"&page=" + param.page;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //新建变量
  newFormulaVar(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaVar/save",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //编辑变量
  updateFormulaVar(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaVar/update",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //删除变量
  deleteFormulaVar(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaVar/delete",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //变量搜索
  queryFormulaVarL(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/formulaVar/list?formulaId="+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //新建常量
  newFormulaConst(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaConst/save",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //编辑常量
  updateFormulaConst(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaConst/update",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //删除常量
  deleteFormulaConst(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaConst/delete",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
   //常量搜索
   queryFormulaVarC(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/formulaConst/list?formulaId="+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //删除公式实例
  deleteFormulaIns(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaIns/delete",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //公式实例
  queryFormulaFIns(data) {
    let token = getToken();
    let param = {"formulaId": data.formulaId,"limit":data.limit,"page":data.page};
    let url = baseUrl + "/sys/formulaIns/list?formulaId="+ param.formulaId +"&limit=" + param.limit+"&page=" + param.page;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //公式实例
  queryFormulaFInslie(data) {
    let token = getToken();
    let param = {"deviceId": data.deviceId,"deviceType":data.deviceType};
    let url = baseUrl + "/sys/formulaIns/list?deviceId="+ param.deviceId +"&deviceType=" + param.deviceType;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  queryFormulaInsa(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/formulaIns/list?insId="+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //新建公式实例
  newFormulaIns(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/formulaIns/save",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //公式常量搜索
  queryConstInCstance(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/constInstance/list?insId="+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //新建公式常量
  queryConstInCstanceSave(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/constInstance/save",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //编辑公式常量
  queryConstInCstanceUpdate(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/constInstance/update",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //删除公式常量
  queryConstInCstanceDelete(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/constInstance/delete",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //公式变量搜索
  queryVarInstance(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/varInstance/list?insId="+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  queryInfo(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/formulaExpression/info/"+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //清除公式实例
  formulaInsReset(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/formulaIns/reset/"+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  queryFormulaInsInfo(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/formulaIns/info/"+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  queryChannel(data) {
    let token = getToken();
    let param = {"id": data.formulaId};
    let url = baseUrl + "/sys/formulaIns/chan/"+ param.id;
    return axios.request({
      url: url,
      data: param,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  //新建公式变量
  queryVarInstanceSave(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/varInstance/save",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //编辑公式变量
  queryVarInstanceUpdate(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/varInstance/update",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //删除公式变量
  queryVarInstanceDelete(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/varInstance/delete",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
};
